import React from "react";
import "./Blog.css";
import { Link } from "react-router-dom";
import { data } from "../../data/blogData";
const Blog = () => {
  return (
    <div className="blogs-section">
      <div className="blog-section-banner">
        <img
          src="https://img.freepik.com/free-photo/type-entertainment-complex-popular-resort-with-pools-water-parks-turkey-with-more-than-5-million-visitors-year-amara-dolce-vita-luxury-hotel-resort-tekirova-kemer_146671-18728.jpg?uid=R197373896&ga=GA1.1.522528783.1742961482&semt=ais_hybrid&w=740"
          alt=""
          srcset=""
        />
      </div>
      <div className="new-blog-secion">
        <h1 className="blog-heading">Latest Blogs</h1>
        <div className="blog-container">
          {data.slice(0, 4).map((item, index) => (
            <Link
              style={{ textDecoration: "none", color: "none" }}
              to={`/blog-details/${item.id}`}
            >
              <div key={index} className="blog-card">
                <img src={item?.images} alt="" srcset="" />
                <div className="blog-content">
                  <h3>{item.title}</h3>
                  <p>{item.description} </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* <div className='more-blogs'>
            <h1 className='blog-heading'>More Blogs</h1>
            <div className="blog-container">
                {
                    data.map((item, index) => (
                    <Link style={{textDecoration:'none', color:'none'}} to='/blog-details'>
                        <div key={index} className="blog-card">
                            <img src="https://img.freepik.com/free-photo/type-entertainment-complex-popular-resort-with-pools-water-parks-turkey-with-more-than-5-million-visitors-year-amara-dolce-vita-luxury-hotel-resort-tekirova-kemer_146671-18728.jpg?uid=R197373896&ga=GA1.1.522528783.1742961482&semt=ais_hybrid&w=740" alt="" srcset="" />
                            <div className='blog-content'>
                                <h3>{item.title}</h3>
                                <p>{item.description} </p>

                            </div>
                        </div>
                    </Link>
                    ))
                }
            </div>
        </div> */}
    </div>
  );
};

export default Blog;
